import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'shortNumber',
})
export class ShortNumberPipe implements PipeTransform {
	transform(value: number, isCurrency: boolean = false): string {
		if (!value && value !== 0) {
			return '';
		}

		const absValue = Math.abs(value);
		const sign = value < 0 ? '-' : '';

		let shortValue: number;
		let suffix: string;

		if (absValue >= 1000000000) {
			// Billions
			shortValue = absValue / 1000000000;
			suffix = 'B';
		} else if (absValue >= 1000000) {
			// Millions
			shortValue = absValue / 1000000;
			suffix = 'M';
		} else if (absValue >= 1000) {
			// Thousands
			shortValue = absValue / 1000;
			suffix = 'K';
		} else {
			// Less than 1000
			if (isCurrency) {
				return `${sign}$${Math.round(absValue).toLocaleString()}`;
			}
			return value.toString();
		}

		// Format: Billions show 1 decimal (e.g., 1.6B), others round to whole number (e.g., 80K)
		let formattedValue: string;
		if (suffix === 'B') {
			// Always show 1 decimal for billions
			formattedValue = shortValue.toFixed(1).replace(/\.0$/, '');
		} else {
			// Round to whole number for thousands and millions
			formattedValue = Math.round(shortValue).toString();
		}

		if (isCurrency) {
			return `${sign}$${formattedValue}${suffix}`;
		}

		return `${sign}${formattedValue}${suffix}`;
	}
}
